import React from 'react';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { Highlight } from '../Highlight';
import { bonos, bonosTotal } from '../../data/landing';
export function Bonos() {
  return <section className="bg-white px-5 py-16 md:py-24" data-id="element-47" data-mp="1hj911h4nyec3">
      <div className="mx-auto max-w-5xl" data-id="element-48" data-mp="1ckxt5bxxidwi">
        <SectionHeading eyebrow="Siempre incluidos" title={<>
              5 Bonos <Highlight data-id="element-50" data-mp="ovd72k6hb0j0">estratégicos</Highlight>
            </>} data-id="element-49" data-mp="1cl7j4ziz4l27" />

        <ul className="mt-12 space-y-3" data-id="element-51" data-mp="jxbn7x18ax6h">
          {bonos.map(b => <li key={b.number} className="grid grid-cols-[auto_1fr] gap-4 rounded-2xl border border-gold/60 bg-gold-soft p-5 sm:grid-cols-[auto_1fr_auto] sm:items-center md:p-6" data-id="element-52" data-mp="ylesf47g64u8">
              <span className="flex h-14 w-14 flex-col items-center justify-center rounded-xl bg-gold text-brand" data-id="element-53" data-mp="63ayzx7wkskd">
                <GiftIcon className="h-5 w-5" aria-hidden="true" data-id="element-54" data-mp="14zlnciefzxe" />
                <span className="text-xs font-black" data-id="element-55" data-mp="2zb78w9aqn1qp">{b.number}</span>
              </span>
              <div data-id="element-56" data-mp="348yxoug367qo">
                <p className="text-xs font-black uppercase tracking-wider text-brand/70" data-id="element-57" data-mp="348gxxnu7tbe0">
                  Bono {Number(b.number)}
                </p>
                <p className="text-lg font-extrabold leading-tight text-brand" data-id="element-58" data-mp="3d1su44nnznrr">{b.title}</p>
                <p className="mt-1 text-sm text-charcoal md:text-base" data-id="element-59" data-mp="3d3n3qmthjtgj">{b.description}</p>
              </div>
              <div className="col-span-2 flex items-center justify-between gap-4 border-t border-gold/50 pt-3 sm:col-span-1 sm:flex-col sm:items-end sm:border-t-0 sm:pt-0" data-id="element-60" data-mp="2lamr9ggk7bys">
                <span className="whitespace-nowrap text-sm text-muted" data-id="element-61" data-mp="2peccbvy0zbf2">
                  Valorado: <span className="line-through decoration-danger" data-id="element-62" data-mp="2ucvy9wcmcn7f">{b.value}</span>
                </span>
                <span className="rounded-full bg-brand px-3 py-1 text-sm font-black uppercase text-white" data-id="element-63" data-mp="4lr0bwtat4yz">
                  Gratis
                </span>
              </div>
            </li>)}
        </ul>

        <div className="mt-8 flex flex-col items-center justify-between gap-2 rounded-2xl bg-brand px-6 py-5 text-center sm:flex-row sm:text-left" data-id="element-64" data-mp="25qbbn16unlpt">
          <p className="text-lg text-white" data-id="element-65" data-mp="2fmo5bz2e9zkk">
            Valor total bonos:{' '}
            <span className="font-black line-through decoration-gold decoration-2" data-id="element-66" data-mp="2anl0ofqbtvd4">{bonosTotal}</span>
          </p>
          <p className="text-xl font-black uppercase text-gold" data-id="element-67" data-mp="1mwz3xklrvxif">→ Gratis con tu MegaPack</p>
        </div>
      </div>
    </section>;
}